import { discoveryQueryKeys } from "@features/discovery/queries/useDiscoveryUsers";
import { likedYouQueryKeys } from "@features/discovery/queries/useLikedYouUsers";
import QUERY_KEYS from "@shared/queryKeys";
import type { QueryClient } from "@tanstack/react-query";

export async function invalidatePostEventUnlockQueries(
  queryClient: QueryClient,
  userId: string | null | undefined
): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CURRENT_USER] });

  if (!userId) {
    return;
  }

  await Promise.all([
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CURRENT_USER, userId] }),
    queryClient.invalidateQueries({ queryKey: discoveryQueryKeys.all }),
    queryClient.invalidateQueries({ queryKey: likedYouQueryKeys.all }),
    queryClient.refetchQueries({ queryKey: [QUERY_KEYS.CURRENT_USER, userId] }),
  ]);
}
